import { useId, useState, type ReactNode } from "react";

import { Button, Field, Input } from "./controls";
import styles from "./integrations.module.css";

/**
 * Type the name to confirm something that cannot be undone.
 *
 * The button stays off until the name matches exactly, so a slip of the mouse
 * never deletes anything.
 */
export function DangerConfirm({
  name,
  what,
  action,
  busy = false,
  onConfirm,
  onCancel,
  children,
}: {
  name: string;
  /** What happens, in one or two sentences. */
  what: ReactNode;
  action: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  children?: ReactNode;
}) {
  const id = useId();
  const [typed, setTyped] = useState("");
  const matches = typed.trim() === name.trim();
  return (
    <div className={styles.answer + " " + styles.answerDanger}>
      <div className={styles.answerBody}>{what}</div>
      <Field label={`Type ${name} to confirm`} htmlFor={id}>
        <Input id={id} value={typed} autoComplete="off" onChange={(event) => setTyped(event.target.value)} />
      </Field>
      {children}
      <div className={styles.actions}>
        <Button tone="danger" disabled={!matches || busy} onClick={onConfirm}>
          {busy ? "Working…" : action}
        </Button>
        {onCancel && (
          <Button tone="subtle" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
        )}
      </div>
    </div>
  );
}
